import React, { useEffect, useState } from "react";
import "./App.css";
import { Link, Redirect, useLocation, useHistory } from "react-router-dom";
import Axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "./components/Footer";
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosArrowBack,
} from "react-icons/io";
import { AiOutlineQrcode } from "react-icons/ai";
import { RiQrCodeLine } from "react-icons/ri";
import Header2 from "./components/Header2";
import { Row } from "react-bootstrap";
import { IoQrCodeOutline, IoWarning } from "react-icons/io5";
import md5 from "md5";
import Header from "./layouts/Header";
import SideNav from "./layouts/SideNav";
import { BiMenu } from "react-icons/bi";
import SideNavCust from "./layouts/SideNavCust";
// import QRCode from "qrcode.react";
var QRCode = require("qrcode.react");

const Previewtickets = () => {
  const baseURL = "https://karamale.com/apps/kscanner/webservices.php";
  const location = useLocation();
  const history = useHistory();
  const [query, setQuery] = useState("");
  const [password, setPassword] = useState("");
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [errorDisplay, setErrorDisplay] = useState("none");
  const [previews, setPreviews] = useState([]);
  const [maxAttemtps, setMaxAttempts] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingAttempts, setLoadingAttempts] = useState(true);
  const [refundsAllowed, setRefundsAllowed] = useState(0);

  const isMobile = window.innerWidth <= 768;
  const [isMob, setIsMob] = useState();
  const [collapsed, setCollapsed] = useState(isMobile);

  const customername = localStorage.getItem("customername");
  const eventname = location.state?.eventname || "";

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768;
    setIsMob(mobile);
    setCollapsed((prev) => (mobile ? true : prev));
  };

  useEffect(() => {
    if (localStorage.getItem("customername") === null) {
      return <Redirect to="/login" />;
      //   return exit(1);
    } else {
    }
    const customername = localStorage.getItem("customername");
    const customerid = localStorage.getItem("customerid");
    const eventid = location.state?.eventid;

    if (customername) {
      document.title = customername;
    }

    Axios.get(
      `${baseURL}?query=GET-REFUND-GOVERNANCE-RULES&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setMaxAttempts(response.data.maxAttempts ?? 2);
        setRefundsAllowed(response.data.refundsAllowed);
        setTimeout(() => {
          setLoadingAttempts(false);
        }, 1000);
      })
      .catch((error) => {
        alert(error);
        console.log(error);
      });

    if (customerid && eventid) {
      Axios.get(
        `https://karamale.com/apps/kscanner/webservices.php?query=PREVIEWTICKETS&customerid=${customerid}&eventid=${eventid}`,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          const data = response.data;
          // console.log(data.length);
          setPreviews(response.data ?? []);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch((error) => console.error("Preview fetch error:", error));
    }

    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);

    return () => {
      // this runs on unmount
      window.removeEventListener("resize", updateIsMobile);
    };
  }, [location.state, setPreviews]);

  const refund = (
    ticket_id,
    ticket_number,
    event_name,
    event_id,
    refund_status,
    m_payment_id,
    refund_attempts,
    maxAttempts
  ) => {
    history.push({
      pathname: "/ticket-refund",
      state: {
        ticket_id,
        ticket_number,
        event_name,
        event_id,
        refund_status,
        m_payment_id,
        refund_attempts,
        maxAttempts,
      },
    });
  };

  const getTickets = () => {
    let activeString = "";
    const customerid = localStorage.getItem("customerid");
    const customername = localStorage.getItem("customername");
    const eventid = location.state?.eventid;
    const transactiondate = location.state?.transactiondate;
    const venue = location.state?.venue;
    const eventname = location.state?.eventname;
    const eventtime = location.state?.eventtime;
    const eventday = location.state?.eventday;
    const yearcreated = location.state?.yearcreated;
    const theme = location.state?.theme;
    const admissions = location.state?.admissions;
    const totalcost = location.state?.totalcost;
    let category = "";

    return (
      <div className="pb-2">
        {loading ? (
          <div className="w-100 text-center mt-3">
            <ClipLoader size={25} color="grey" />
          </div>
        ) : (
          <>
            {previews.length < 1 ? (
              <div>
                <label
                  style={{
                    width: "100%",
                    textAlign: "center",
                    fontSize: 13.5,
                    color: "#5B7083",
                  }}
                >
                  No data found{" "}
                </label>
              </div>
            ) : (
              previews.map((item, index) => {
                let attempts =
                  item.refund_status !== null
                    ? Number(item.refundAttempts) + 1
                    : item.refundAttempts;
                {
                  item.activation == 1
                    ? (activeString = (
                        <IoIosCheckmarkCircleOutline size={18} color="green" />
                      ))
                    : (activeString = (
                        <IoIosRemoveCircleOutline size={18} color="red" />
                      ));
                }

                {
                  item.category == "general"
                    ? (category = "General")
                    : (category = item.category.toUpperCase());
                }

                return (
                  <Row
                    key={index}
                    className="align-items-center justify-content-center mb-2"
                  >
                    {item.refund_status === "Approved" ? (
                      <div className="col-12">
                        <label className="alert alert-warning p-2 text-12 mb-0">
                          This ticket has been refunded and is no longer valid.
                        </label>
                      </div>
                    ) : item.refund_status === "Pending" ||
                      item.refund_status === "Under_review" ? (
                      <div className="col-12">
                        <label className="alert alert-info p-2 text-12 mb-0">
                          {item.refund_status === "Under_review"
                            ? "Refund request under review. We'll notify you once a decision is made."
                            : "Refund request submitted. Awaiting review."}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      className={refundsAllowed == 0 ? "col-lg-12" : "col-lg-8"}
                    >
                      <div className="row align-items-center justify-content-center">
                        <Link
                          to={{
                            pathname: "/zoom",
                            state: {
                              customername: customername,
                              customerid: customerid,
                              eventid: eventid,
                              transactiondate: transactiondate,
                              venue: venue,
                              eventname: eventname,
                              eventtime: eventtime,
                              eventday: eventday,
                              yearcreated: yearcreated,
                              theme: theme,
                              admissions: admissions,
                              totalcost: totalcost,
                              ticketnumber: item.ticketnumber,
                              refund_status: item.refund_status,
                            },
                          }}
                          className="row align-items-center"
                          style={{
                            display: "flex",
                            width: "100%",
                            color: "#000",
                          }}
                        >
                          <div
                            className={`${
                              refundsAllowed == 0
                                ? "col-lg-3 col-4 col-sm-4"
                                : "col-lg-4 col-4 col-sm-3"
                            }  p-0`}
                          >
                            <QRCode
                              value={
                                item.refund_status === "Approved" ||
                                item.refund_status === "Pending" ||
                                item.refund_status === "Under_review"
                                  ? md5(item.ticketnumber)
                                  : item.qr_payload ?? ""
                              }
                              logoSize={30}
                              // size={105}
                              fgColor={
                                item.refund_status === "Approved" ||
                                item.refund_status === "Pending" ||
                                item.refund_status === "Under_review"
                                  ? "grey"
                                  : "#000"
                              }
                              bgColor={"#fff"}
                              className={"preview_tickets_qrcode"}
                            />
                          </div>
                          <div
                            className="col-lg-8 col-8 col-sm-8 p-0"
                            style={{ cursor: "pointer" }}
                          >
                            <label
                              className="item-names"
                              style={{
                                color: "#000",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                            >
                              <label
                                className={
                                  item.refund_status === "Approved" ||
                                  item.refund_status === "Pending" ||
                                  item.refund_status === "Under_review"
                                    ? "text-grey text-12 font-normal mt-1"
                                    : "admin-cate mt-1"
                                }
                              >
                                <span>Ticket Number:</span> {item.ticketnumber}{" "}
                                <br />
                                <span>Type:</span> {category} admission
                                <br />
                                <span>Admissions:</span> {item.quantity}
                                <br />
                                <span>Price:</span> R
                                {Number(
                                  item.age_group == 1
                                    ? item.kids_price
                                    : item.price
                                ).toFixed(2)}{" "}
                                x {item.quantity}
                                <br />
                                <span>Issued On:</span> {item.created_at}
                                <br />
                                <span>Time of Issue:</span> {item.time_at}
                              </label>
                            </label>
                          </div>
                        </Link>
                      </div>
                    </div>
                    <div
                      className={
                        refundsAllowed == 0 ? "d-none" : "col-lg-4 text-right"
                      }
                    >
                      {item.refund_status !== null ? (
                        <label className="text-grey mb-0">
                          Refund{" "}
                          {item.refund_status.replace("_", " ").toLowerCase()}
                        </label>
                      ) : (
                        ""
                      )}
                      <button
                        type="button"
                        onClick={() =>
                          !item.qr_payload
                            ? alert(
                                "This pass is invalid. Refunds are not available."
                              )
                            : refund(
                                item.ticket_id,
                                item.ticketnumber,
                                item.event_name,
                                item.event_id,
                                item.refund_status,
                                item.m_payment_id,
                                attempts,
                                item.maxAttempts
                              )
                        }
                        className={
                          !item.qr_payload
                            ? "btn-disabled w-100 font-normal mb-3"
                            : item.refund_status === "Pending" ||
                              item.refund_status === "Under_review"
                            ? "warning-btn w-100 mr-2 font-normal mb-3"
                            : item.refund_status === "Approved" ||
                              attempts === item.maxAttempts
                            ? "btn-disabled w-100 font-normal mb-3"
                            : "save-btn w-100 mr-2 font-normal mb-3"
                        }
                        disabled={
                          item.refund_status === "Approved" ||
                          attempts === item.maxAttempts
                            ? true
                            : false
                        }
                      >
                        {!item.qr_payload
                          ? "QR code invalid"
                          : item.refund_status === "Pending" ||
                            item.refund_status === "Under_review"
                          ? "Cancel Request"
                          : item.refund_status === "Approved"
                          ? `${item.refund_status}`
                          : "Request Refund"}
                      </button>
                      <label className="text-grey mb-0">
                        {attempts}/{item.maxAttempts} Attempts
                      </label>
                    </div>
                    <div className="h-divider w-100"></div>
                  </Row>
                );
              })
            )}
          </>
        )}
      </div>
    );
  };

  const handleToggle = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="view">
      {/* <Header2 /> */}
      <Header />
      <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="container"
        style={{
          marginTop: 40,
          marginLeft: isMob ? "0px" : collapsed ? "auto" : "auto",
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={handleToggle} />
        )}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid mt-5">
          <div className="col-lg-7 pl-0 pr-0">
            <h5>{eventname}</h5>
            <div className=" BoxDashboardContainer mt-0 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-12 pl-0">
                    <button
                      type="button"
                      onClick={() => history.goBack()}
                      className="link-btn"
                    >
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>

                  {/* <div className="col-lg-8 col-8 text-right">
                    <label className="back-arrow">
                      <IoIosInformationCircleOutline size={40} color={"#fff"} />
                      &nbsp;&nbsp;&nbsp;{" "}
                      <span className="note-info">{eventname}</span>
                    </label>
                  </div> */}
                </div>
              </div>
            </div>
            {loadingAttempts ? (
              <div className="text-center w-100 mb-3">
                <ClipLoader size={25} color="grey" />
              </div>
            ) : (
              <div
                className={
                  refundsAllowed == 0 ? "alert alert-danger p-02" : "d-none"
                }
              >
                <span>Refunds are not available for this event.</span>
                <br />
                The organizer has chosen to disable refund requests across all
                ticket types.
              </div>
            )}
            <div className=" BoxDashboardContainer pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-12 pl-0">
                    <label className="ticket-title pl-0 pr-0">
                      CLICK TO PREPARE FOR SCANNING
                    </label>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
              </div>
              {getTickets()}
            </div>
          </div>
        </div>
      </div>
      <div
        className="error-login"
        style={{ display: errorDisplay, textAlign: "center" }}
      >
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Previewtickets;
